<div class="asset-tab-container">
	<div class="tab-header">
		<button mat-icon-button class="primary-icon-button">
			<mat-icon svgIcon="add"></mat-icon>
		</button>
	</div>
	<div class="entity-list">
		<div class="entity-list-header">
			<h3>{{ 'attached_assets' | translate }}</h3>

			<button mat-icon-button [matMenuTriggerFor]="actionsMenu">
				<mat-icon svgIcon="more_vert"></mat-icon>
			</button>
		</div>
		@for (asset of assets(); track asset.pk) {
			<mat-card class="attached-entity-card">
				<mat-card-content class="card-content">
					<mat-checkbox
						class="content-checkbox"
						[checked]="assetSelections.isSelected(asset)"
						(change)="assetSelections.toggle(asset)"
					/>
					<div class="content-info">
						<mat-card-title class="card-title">
							{{ asset.name }}
						</mat-card-title>

						<mat-card-subtitle class="card-subtitle">
							{{ asset.location?.name }}
						</mat-card-subtitle>
					</div>
				</mat-card-content>
				<div class="card-img">
					<mat-icon svgIcon="asset"></mat-icon>
					{{ 'asset' | translate }}
				</div>
			</mat-card>
		} @empty {
			<mat-icon svgIcon="sad-robot"></mat-icon>
			<p>{{ 'nothing' | translate }}</p>
		}
	</div>
</div>

<mat-menu #actionsMenu="matMenu">
	<button
		mat-menu-item
		[disabled]="!assetSelections.selected.length"
		(click)="unlinkAssets()"
	>
		<mat-icon svgIcon="remove-attachment"></mat-icon>
		{{
			'unlink_asset' | translate: { value: assetSelections.selected.length.toString() }
		}}
	</button></mat-menu
>
